import styled from '@emotion/styled/macro';

export const EmployeesPageContainer = styled.main`
  display: flex;
  flex-direction: column;
  height: 100%;
  /* max-height: calc(100% - 83px); */
  padding: 1em 2em;
  background-color: #f0f0f7;
  box-sizing: border-box;
`;

export const SelectEmployeeLabel = styled.p`
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
`;

export const EmployeeFlexDiv = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;
`;

export const EmployeeProfile = styled.div`
  margin: 1rem 0px 0px 1rem;
`;

export const EmployeeName = styled.p`
  font-size: 1rem;
  font-weight: bold;
`;

export const EmployeePosition = styled.p`
  color: gray;
  font-size: 0.875rem;
`;

export const SelectEmployeeContainer = styled.div`
  width: 20%;
  margin-right: 1rem;
`;

export const AutocompleteContainer = styled.div`
  background-color: white;
  width: 100%;
`;
